import React from 'react';
import './GeolocationLink.less';
import Platform from "../../../platform";

export const GeolocationLink = ({latitude, longitude, address, zip = '', children}) => {

	const url = `https://www.google.com/maps/search/?api=1&query={queryString}`;
	let query;

	if (latitude && longitude) {
		query = `${latitude}, ${longitude}`;
	} else {
		query = `${encodeURI(address)}, ${zip}`;
	}

	return <a href={url.replace('{queryString}', query)} target="_blank" className="geolocation-link">{children}</a>
}
